export const  personalDetail = {
    picture: "",
    name: "",
    age: '0',
    gender: "",
    phone: "",
    email: "",
  }

